import React from "react";
import styles from "./index.module.scss";
const StepLine = () => {
    return React.createElement("div", { className: styles.stepLine });
};
export default StepLine;
